/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import { logger } from '@zcode/utils'
import type { ErrorBoundaryProps } from 'react-error-boundary'

const fallbackStyle = css`
  height: 400px;
`

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for MarketingSection lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for MarketingSection lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () => await import('./MarketingSection')

const handleReload = async () => await MarketingLazyLoadableSection.reload()

const options = {
  errorFallback: () => (
    <ErrorFallback
      css={fallbackStyle}
      message="Error loading the marketing section"
      onClickReload={handleReload}
    />
  ),

  loadingFallback: () => <LoadingFallback css={fallbackStyle} name="marketing section" />,
  onRenderError,
  onLoadingError,
}

export const MarketingLazyLoadableSection = createLazyLoadableSection(loadFn, options)
